<template>
  <label>
    <date-range-picker
      v-model="childDateRange"
      opens="left"
      style="overflow: hidden;"
      control-container-class="daterangepicker-custom"
      :date-format="dateFormat"
      :append-to-body="true"
      :single-date-picker="singleDatePicker"
      :time-picker="timePicker"
      :ranges="false"
      :locale-data="localeData"
      :show-dropdowns="true"
      @update="update"
    >
      <template v-slot:input="picker">
        <div v-if="singleDatePicker">
          {{ picker.startDate | dateFormat }}
        </div>
        <div v-else>
          {{ picker.startDate | dateFormat }} - {{ picker.endDate | dateFormat }}
        </div>
      </template>
    </date-range-picker>
  </label>
</template>

<script>
import dateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import { showNotice } from '@/utils/tool'

export default {
  components: {
    dateRangePicker
  },
  props: {
    'value': {
      type: Object,
      default: () => {}
    },
    'singleDatePicker': {
      type: Boolean,
      default: false
    },
    'timePicker': {
      type: Boolean,
      default: false
    },
    'limitTreeDay': {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      childDateRange: {},
      localeData: {
        direction: 'ltr',
        separator: ' - ',
        applyLabel: this.$t('Bao.confirm'),
        cancelLabel: this.$t('Bao.cancel'),
        weekLabel: 'W',
        customRangeLabel: '自選範圍',
        daysOfWeek: [this.$t('Bao.sun'), this.$t('Bao.mon'), this.$t('Bao.tue'), this.$t('Bao.wed'), this.$t('Bao.thu'), this.$t('Bao.fri'), this.$t('Bao.sat')],
        monthNames: [this.$t('Bao.jan'), this.$t('Bao.feb'), this.$t('Bao.mar'), this.$t('Bao.apr'), this.$t('Bao.may'), this.$t('Bao.jun'), this.$t('Bao.jul'), this.$t('Bao.aug'), this.$t('Bao.sep'), this.$t('Bao.oct'), this.$t('Bao.nov'), this.$t('Bao.dec')],
        firstDay: 0
      }
    }
  },
  created() {
    this.childDateRange = this.value
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() > moment().toDate()
      }
      return classes
    },
    update() {
      const diffTime = Math.abs(this.childDateRange.endDate - this.childDateRange.startDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      if (this.limitTreeDay) {
        if (diffDays >= 3) {
          this.childDateRange.startDate = moment().subtract(3, 'd').toDate()
          this.childDateRange.endDate = new Date()
          showNotice(this.$t('Bao.date_range_limit_tree_day'))
        }
      } else {
        if (diffDays > 90) {
          this.childDateRange.startDate = moment().subtract(7, 'd').toDate()
          this.childDateRange.endDate = new Date()
          showNotice(this.$t('Bao.date_range_limit_tree_month'))
        }
      }
      this.$emit('input', this.childDateRange)
      this.$emit('query')
    }
  }
}
</script>

<style>
.daterangepicker-custom{
  padding-top: 4px;
  width: 300px;
}
</style>

